export const SEARCH_REQUESTED = 'stores/SEARCH_REQUESTED'
export const DETAILS_REQUESTED = 'stores/DETAILS_REQUESTED'
export const SEARCH_ALL_STORES_REQUESTED = 'stores/SEARCH_ALL_STORES_REQUESTED'

export const SEARCH_TERM_UPDATED = 'stores/SEARCH_TERM_UPDATED'
export const SEARCH_TERM_CLEARED = 'stores/SEARCH_TERM_CLEARED'
export const AREA_UPDATED = 'stores/AREA_UPDATED'
export const FILTERS_UPDATED = 'stores/FILTERS_UPDATED'
export const FILTERS_CLEARED = 'stores/FILTERS_CLEARED'

export const LOAD_MORE_RESULTS = 'stores/LOAD_MORE_RESULTS'
export const LOAD_MORE_RESULTS_REQUESTED = 'stores/LOAD_MORE_RESULTS_REQUESTED'
export const SELECTED_STORE_UPDATED = 'stores/SELECTED_STORE_UPDATED'
export const SELECTED_MARKER_UPDATED = 'stores/SELECTED_MARKER_UPDATED'
export const CLEAR_SELECTED_MARKER = 'stores/CLEAR_SELECTED_MARKER'

export const CLEAR_ALL = 'stores/CLEAR_ALL'
